import { CloudImage } from '@components/CloudImage';
import styled from 'styled-components';
import { Flex } from '@components/Flex';
import { Text } from '@components/typography';
import { themeColor, themeMediaQuery, themeSpace } from '@utils/styledTheme.util';

const MOBILE_TOP_TEXT_CONTAINER = '80px';
const MOBILE_WIDTH_TEXT_CONTAINER = '394px';

const DESKTOP_TOP_TEXT_CONTAINER = '195px';
const DESKTOP_WIDTH_TEXT_CONTAINER = '452px';
const DESKTOP_XL_WIDTH_TEXT_CONTAINER = '560px';

const MOBILE_HEIGHT_IMAGE = '739px';
const DESKTOP_HEIGHT_IMAGE = '1315px';

export const WebsiteImage = styled(CloudImage)`
  object-fit: cover;
  height: ${DESKTOP_HEIGHT_IMAGE};
  ${themeMediaQuery('below_sm')} {
    display: none;
  }
`;

export const TextDiv = styled(Text)`
  color: ${themeColor('yellow5')};
  text-align: center;
`;

export const WebsiteImageMobile = styled(CloudImage)`
  display: none;
  ${themeMediaQuery('below_sm')} {
    height: ${MOBILE_HEIGHT_IMAGE};
    height: auto;
    max-width: 100%;
    object-fit: cover;
    display: block;
  }
`;

export const TextContainer = styled.div`
  position: absolute;
  color: ${themeColor('yellow5')};
  padding: 0 ${themeSpace(6)};
  top: ${MOBILE_TOP_TEXT_CONTAINER};
  max-width: ${MOBILE_WIDTH_TEXT_CONTAINER};
  ${themeMediaQuery('sm')} {
    padding: 0;
    top: ${DESKTOP_TOP_TEXT_CONTAINER};
    max-width: ${DESKTOP_WIDTH_TEXT_CONTAINER};
  }
  ${themeMediaQuery('xl')} {
    max-width: ${DESKTOP_XL_WIDTH_TEXT_CONTAINER};
  }
`;

export const ImageWrapper = styled(Flex)`
  position: relative;
  width: 100%;
  justify-content: center;
  height: ${DESKTOP_HEIGHT_IMAGE};
  ${themeMediaQuery('below_sm')} {
    height: ${MOBILE_HEIGHT_IMAGE};
  }
`;
